<es-details-subcard [title]="('ENTRY_SUMMARY.INVOICE' | translate) + indexSuffix" [mode]="'secondary'">
  <div action class="summary-card-edit" *ngIf="canEdit">
    <dropdown-action [iconColor]="iconColor" [menuMode]="menuMode" [id]="'es-invoice-action-' + invoice.id" className="d-print-none">
      <button dropdown-item class="dropdown-item" (click)="goToEditInvoice()">
        {{ "BUTTON.EDIT" | translate }}
      </button>
      <button dropdown-item class="dropdown-item" (click)="isInvoiceConfirmModalOpen = true">
        {{ "BUTTON.DELETE" | translate }}
      </button>
    </dropdown-action>
  </div>
  <div *ngIf="validationMessages.length || manufacturerValidationMessages.length || linesValidationMessages.length" class="row">
    <div class="error-message col-12" *ngFor="let message of validationMessages">
      {{ "BACK_ERROR.SHIPMENTS.INVOICES." + message.text | translate : message.params }}
    </div>
    <div class="error-message col-12" *ngFor="let message of manufacturerValidationMessages">
      {{ "BACK_ERROR.SHIPMENTS.INVOICES.MANUFACTURER." + message.text | translate : message.params }}
    </div>
    <div class="error-message col-12" *ngFor="let message of linesValidationMessages">
      {{ "BACK_ERROR.SHIPMENTS.INVOICES.LINES." + message.text | translate : message.params }}
    </div>
  </div>
  <ng-template [ngIf]="invoice.lines && invoice.lines.length">
    <div class="row">
      <div class="col-4">
        <b>{{ "FORM_LABEL.HTS_CODE" | translate }}</b>
      </div>
      <div class="col-4">
        <b>{{ "LABELS.GROSS_WEIGHT" | translate }}</b>
      </div>
      <div class="col-4">
        <b>{{ "FORM_LABEL.ENTERED_VALUE" | translate }}</b>
      </div>
    </div>
    <div *ngFor="let line of invoice.lines" class="row">
      <div class="col-4">
        {{ line.htsNumber | mask : HTS_MASK }}
      </div>
      <div class="col-4">{{ line.grossWeight | number : "1.2-2" }} kg</div>
      <div class="col-4">
        <ng-template [ngIf]="invoice.currency === DEFAULT_CURRENCY_CODE">
          {{ line.value | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
        </ng-template>
        <ng-template [ngIf]="invoice.currency !== DEFAULT_CURRENCY_CODE">
          {{ line.value | currency : invoice.currency : "" : "1.2-2" }} {{ invoice.currency }}
        </ng-template>
      </div>
    </div>
  </ng-template>
</es-details-subcard>

<custom-modal [header]="'LABELS.DELETE_INVOICE'" [(open)]="isInvoiceConfirmModalOpen">
  <div>{{ "DELETE_ITEM_TEXT" | translate }}</div>

  <button footer-action type="button" class="btn btn-primary" (click)="onDeleteInvoice()">{{ "LABELS.YES" | translate }}</button>

  <button footer-action type="button" class="btn btn-secondary ml-2" (click)="isInvoiceConfirmModalOpen = false">
    {{ "LABELS.NO" | translate }}
  </button>
</custom-modal>
